export default "__VITE_ASSET__I0NA5lSt__"